import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Group = styled.section`
  border: 1px solid ${rawColors.grey[200]};
  border-radius: 0.5rem;
  background: ${rawColors.structural.white};
`;
export const GroupHead = styled.header`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  padding: ${spacing[3]} ${spacing[4]};
`;
export const GroupTitle = styled.h3`
  margin: 0;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
`;
export const Summary = styled.span`
  margin-left: auto;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;
export const GroupBody = styled.div`
  padding: 0 ${spacing[4]};
  border-top: 1px solid ${rawColors.grey[200]};
`;
export const Row = styled.div<{ $stacked: boolean; $dim: boolean }>`
  display: flex;
  flex-direction: ${({ $stacked }) => ($stacked ? "column" : "row")};
  align-items: ${({ $stacked }) => ($stacked ? "stretch" : "center")};
  gap: ${spacing[3]};
  padding: ${spacing[3]} 0;
  min-height: 3.5rem;
  opacity: ${({ $dim }) => ($dim ? 0.7 : 1)};
  & + & {
    border-top: 1px solid ${rawColors.grey[200]};
  }
`;
export const Copy = styled.div`
  flex: 1;
  min-width: 0;
`;
export const Label = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[1]} ${spacing[2]};
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
`;
export const Hint = styled.div`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;
